
require("../../node_modules/van11y-accessible-modal-window-aria/src/van11y-accessible-modal-window-aria.es6");